@if (editInline()) {
    <se-date-cell-editor-inline
        [dateFormControl]="formControl"
        [inputType]="inputType()"
        [dateInputFormat]="dateInputFormat()"
        [timeInputFormat]="timeInputFormat()"
        [cellReady]="cellReady()"
    >
    </se-date-cell-editor-inline>
} @else {
    <se-date-cell-editor-popup
        [dateFormControl]="formControl"
        [inputType]="inputType()"
        [dateInputFormat]="dateInputFormat()"
        [timeInputFormat]="timeInputFormat()"
        [cellReady]="cellReady()"
        [width]="cellWidth()"
    ></se-date-cell-editor-popup>
}
